module.exports = __webpack_public_path__ + "img/CS4-2.3587c8cf.png";